<template>
    <el-select
        v-model="localValue"
        :remote="true"
        :remote-method="search"
        :loading="loading"
        :placeholder="placeholder"
        :filterable="true"
        style="width: 100%"
        @change="updateValue"
    >
        <el-option
            v-for="item in localEmployers"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
    </el-select>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
        },
        employers: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: "Enter an employer",
        },
        inactive: {
            type: Boolean,
            default: false,
        },
        remote: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            localValue: this.value,
            localEmployers: this.employers,
            loading: false,
        };
    },
    watch: {
        value(newValue) {
            this.setLocalValue(newValue);
        },
    },
    methods: {
        setLocalValue(newValue) {
            this.localValue = newValue;
        },
        updateValue(newValue) {
            this.localValue = newValue;

            this.$emit('input', newValue);
            this.$emit('change', newValue);
        },
        search(query) {
            // TODO: debounce
            if (query === '' || query.length < 2) {
                return;
            }
            this.loading = true;

            return axios.post(url(`admin/employer-dropdown/search`), {
                search: query,
            }).then(response => {
                this.localEmployers = response.data;
                this.loading = false;
            });
        },
    }
}
</script>
